import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { LineInterface } from '../../../lines/models/line.interface';
import { UpdateSelectedProcedure } from '../../../shared/store/actions/selected-procedure.actions';
import { CustomerMsisdnNotificationPaginatorInterface } from '../../../shared/models/customer-msisdn-notification-paginator.interface';
import { LandLineListInterface } from '../../models/land-line-list.interface';
import { LandLineListInterfaceState } from '../../store/state/land-line-list.state';
import { GetLandLineList } from '../../store/actions/land-line-list.actions';
import { ESetSelectedLandLineActions, SetSelectedLandLine } from '../../store/actions/selected-landline.actions';
import { Actions, ofType } from '@ngrx/effects';
import { LandlineConsumptionInterfaceState } from '../../store/state/land-line-consumption.state';
import { LandlineConsumptionInterface } from '../../models/landline-consumption.interface';
import { GetLandlineConsumption } from '../../store/actions/land-line-consumption.actions';

@Component({
  selector: 'app-land-lines-list',
  templateUrl: './land-lines-list.component.html',
  styleUrls: ['./land-lines-list.component.css'],
  standalone: false
})
export class LandLinesListComponent implements OnInit {

  constructor(
    private actions$: Actions,
    private store: Store<any>,
    private activateRoute: ActivatedRoute,
    private location: Location
  ) {}

  consumptionTab: string;
  documentsTab: string;
  lineManagementTab: string;
  notificationsTab: string;
  landLineList: Array<LandLineListInterface>|null;
  landlineConsumption: LandlineConsumptionInterface = null;
  selectedLandLine: LandLineListInterface|null = null;
  modalVisibility: boolean = false;
  arrowImage: string = 'arrow_down';
  selectedProcedure: string = null;
  notificationsPaginator: CustomerMsisdnNotificationPaginatorInterface;
  line: LineInterface = null;
  faqPageCode: string;
  procedureInParam: string;

  listLinesStatus(e: number) {
    if (e === 1) {
      this.arrowImage = 'arrow_down';
      this.modalVisibility = false;
    }
  }

  ngOnInit() {
    this.store.pipe(select(ConstsHelper.REDUCER_LAND_LINES_LIST)).subscribe((response: LandLineListInterfaceState) => {
      if (response.list instanceof Array && response.list.length > 0) {
        this.landLineList = response.list;
        this.store.dispatch(new SetSelectedLandLine(this.landLineList[0]));
        this.setActiveTab(this.activateRoute.snapshot.params['tab'], false);
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_LAND_LINE_CONSUMPTION)).subscribe((response: LandlineConsumptionInterfaceState) => {
      if (null !== response.landlineConsumption) {
        if (response.landlineConsumption.date == null) {
          this.landlineConsumption = null;
        } else {
          this.landlineConsumption = response.landlineConsumption;
        }
      }
    });

    this.landLineList = null;
    this.selectedProcedure = null;
    this.store.dispatch(new GetLandLineList());
    this.actions$.pipe(ofType(ESetSelectedLandLineActions.SetSelectedLandLine)).subscribe((result: SetSelectedLandLine) => {
      if (this.selectedLandLine == null || (this.selectedLandLine.phoneNumber !== result.payload.phoneNumber) && window.location.href.includes('suiviconso')) {
        this.selectedLandLine = result.payload;
        this.store.dispatch(new GetLandlineConsumption(this.selectedLandLine.phoneNumber));
        this.modalVisibility = false;
        this.arrowImage = 'arrow_down';
      }
    });
  }

  setActiveTab(tab: string, withParams: boolean) {
    this.consumptionTab = '';
    this.documentsTab = '';
    this.lineManagementTab = '';
    this.notificationsTab = '';
    if (['', 'undefined', undefined].indexOf(tab) !== -1) {
      tab = 'suiviconso';
      this.faqPageCode = 'lines_suiviconso';
    }
    switch (tab) {
      case 'suiviconso':
        this.consumptionTab = 'active';
        this.faqPageCode = 'lines_suiviconso';
        break;
      case 'infos':
        this.documentsTab = 'active';
        this.faqPageCode = 'lines_infos';
        break;
      case 'gestion':
        this.lineManagementTab = 'active';
        this.faqPageCode = 'lines_gestion';
        break;
    }
    this.store.dispatch(new UpdateSelectedProcedure(''));
    let url = '/fixes/' + tab;
    if (this.procedureInParam && withParams) {
      url += '/' + this.procedureInParam;
    }
    this.location.replaceState(url);
  }

  linesListVisibility() {
    if (this.selectedProcedure == null || this.selectedProcedure === '') {
      this.modalVisibility = !this.modalVisibility;
      if (this.modalVisibility) {
        this.arrowImage = 'arrow_up';
      } else {
        this.arrowImage = 'arrow_down';
      }
    }
  }
}
